<template>
  <ul class="applyAbstract_wrap">
    <li
      class="applyAbstract_box"
      v-for="(hospital, i) in hospitalList"
      :key="i"
    >
      <p class="applyAbstract_name">{{ hospital?.name.content }}</p>
      <p
        class="applyAbstract_program"
        v-if="hospital.program?.content"
        v-html="`プログラム名：${hospital?.program?.content}`"
      />
      <ul class="applyAbstract_list">
        <li>{{ hospital?.address.label }}：{{ hospital?.address.content }}</li>
        <li>{{ hospital?.tel.label }}：{{ hospital?.tel.content }}</li>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
type DetailObj = { label: string; content: string }
type ApplyHotelAbstractObj = {
  name: DetailObj
  address: DetailObj
  tel: DetailObj
  program?: DetailObj
}

export default defineComponent({
  name: 'ApplyHotelAbstract',
  props: {
    hospitalList: Array as PropType<ApplyHotelAbstractObj[]>
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.applyAbstract_wrap {
  display: grid;
  gap: 16px 0;
}
.applyAbstract_box {
  min-width: 0px;
  padding: 16px;
  font-size: 1.3rem;
  letter-spacing: 0.03em;
  background-color: #f5f5f5;
  @include mixins.media() {
    margin-bottom: 1.4rem;
  }
}
.applyAbstract_name {
  font-weight: 500;
  margin-bottom: 4px;
}
.applyAbstract_program {
  font-weight: 400;
}
.applyAbstract_list {
  display: grid;
  > li {
    min-width: 0px;
  }
  @include mixins.media() {
    display: inline-flex;
    > li {
      &:not(:first-child) {
        margin-left: 1em;
      }
    }
  }
}
</style>
